export const VARIATIONS = {
  FULL_BLEED: 'FULL_BLEED',
  CONDENSED: 'CONDENSED',
  CONTROL: 'CONTROL',
};

export const ALIGNMENT_OPTIONS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER',
};

export const BREAKPOINTS = {
  SMALL: 'SMALL',
  MEDIUM_UP: 'MEDIUM_UP',
};

export const VARIATION_DIMENSIONS = {
  [VARIATIONS.FULL_BLEED]: {
    MOBILE_TITLE_FONT_SIZE: 18,
    MOBILE_DESC_FONT_SIZE: 14,
    IMAGE_RATIOS: {
      [BREAKPOINTS.SMALL]: '6:5',
      [BREAKPOINTS.MEDIUM_UP]: '25:6',
    },
  },
  [VARIATIONS.CONDENSED]: {
    MOBILE_TITLE_FONT_SIZE: 25,
    MOBILE_DESC_FONT_SIZE: 16,
    IMAGE_RATIOS: {
      [BREAKPOINTS.SMALL]: '19:7',
      [BREAKPOINTS.MEDIUM_UP]: '19:7',
    },
  },
  [VARIATIONS.CONTROL]: {
    MOBILE_TITLE_FONT_SIZE: 32,
    MOBILE_DESC_FONT_SIZE: 16,
    IMAGE_RATIOS: {
      [BREAKPOINTS.SMALL]: '47:25',
      [BREAKPOINTS.MEDIUM_UP]: '47:25',
    },
  },
};
